import { motion } from 'framer-motion';
import { Trophy, Award, Medal } from '../icons';
import type { CoachRanking } from '../../lib/partner-dashboard';

interface TopCoachesProps {
  coaches: CoachRanking[];
  locale?: string;
}

function getRankIcon(index: number) {
  if (index === 0) return <Trophy className="w-5 h-5 text-warm-500" />;
  if (index === 1) return <Award className="w-5 h-5 text-gray-40" />;
  if (index === 2) return <Medal className="w-5 h-5 text-warm-400" />;
  return null;
}

export function TopCoaches({ coaches, locale }: TopCoachesProps) {
  const tr = locale === 'tr';
  if (coaches.length === 0) {
    return (
      <div className="freud-card-elevated p-6">
        <h3 className="text-text-xl text-gray-80 mb-4">{tr ? 'En Iyi Koclar' : 'Top Coaches'}</h3>
        <p className="text-text-sm text-gray-40 text-center py-6">
          {tr ? 'Henuz koc aktivitesi yok' : 'No coach activity yet'}
        </p>
      </div>
    );
  }

  const maxCount = coaches[0]?.completedAssessments || 1;

  return (
    <div className="freud-card-elevated p-6">
      <h3 className="text-text-xl text-gray-80 mb-4">{tr ? 'En Iyi Koclar' : 'Top Coaches'}</h3>
      <div className="space-y-3">
        {coaches.map((coach, index) => (
          <motion.div
            key={coach.coachId}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            className="flex items-center gap-3"
          >
            <div className="w-7 flex-shrink-0 flex items-center justify-center">
              {getRankIcon(index) || (
                <span className="text-text-sm text-gray-40 font-medium">
                  {index + 1}
                </span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-text-sm text-gray-80 font-medium truncate">
                  {coach.coachName}
                </span>
                <span className="text-text-sm text-gray-50 font-semibold ml-2 flex-shrink-0">
                  {coach.completedAssessments}
                </span>
              </div>
              <div className="w-full bg-brand-10 rounded-full h-1.5">
                <motion.div
                  className="bg-success-40 h-1.5 rounded-full"
                  initial={{ width: 0 }}
                  animate={{ width: `${(coach.completedAssessments / maxCount) * 100}%` }}
                  transition={{ duration: 0.6, delay: index * 0.05 }}
                />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
